<template>
  <div class="body-wrapper">
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        Upravljanje upravnicima
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="badge--mod fas fa-users"></i>
        </transition>
      </h1>
      <!-- <h2>{{ communityType }}</h2> -->
    </div>
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-show="!loading">
          <button @click="showModal('ModalContentAddUser')" class="btn">
            Novi korisnik
          </button>
          <data-table
            :columns="table.tableColumns"
            :tableData="tableData"
            :options="table.tableOptions"
            :slotNameActionAllUsers="'action'"
            @row-click="openUserDetails"
          ></data-table>
          <!-- :slotDatePost="'time'" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';
import { UserRoles } from '@/util/UtilService.js';

export default {
  components: {
    DataTable
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  created() {
    // only super manager can access this page
    if (
      this.$store.getters.getUser.roles.indexOf(UserRoles.SUPER_MANAGER) == -1
    ) {
      this.$router.push('/notFound');
    }
    //loading data to table
    this.getAllUsers(this.$store.getters.getUser.id);
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
  },
  data() {
    return {
      table: {
        tableColumns: ['fullName', 'email', 'phone', 'roleNames', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            fullName: 'Ime',
            email: 'Email',
            phone: 'Broj telefona',
            roleNames: 'Rola',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje upravnici'
          },
          sortable: ['file_name']
        }
      }
    };
  },
  methods: {
    ...mapActions('table', ['getAllUsers']),
    ...mapMutations(['cardOpened']),
    ...mapMutations('modal', ['showModal', 'showModalWider']),
    ...mapMutations('table', ['setTableBadge', 'unsetTableData']),
    back() {
      this.$router.back();
    },
    openUserDetails(data) {
      this.$router.push({
        name: 'managerDetails',
        params: {
          userId: data.row.id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.body-wrapper {
  display: block;
  padding: 10px;

  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

.btn {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.btn:focus {
  box-shadow: none;
}
</style>
